import React from "react";
import Header from "../components/header/header";
import CountdownTimer from "../components/extras/countdown";
import HomeImage from '../images/headers/ut-campus-filetest.jpg';    /* rename image when changed : see tip ## */
import Logo from '../images/mdm2025.png';
import '../App.css';
import '../style/home.css';
// import '../style/sponsor.css';
import CustomLink from "../components/navigation/customlink";
import {Link} from "react-router-dom";
import Map from "../components/extras/Map";
// import Logo25 from "../images/MDM-Logo.png";

const Home = () => {
    return (
        <>
            {/* <div className="temp-hornraiser">
            <span>Hornraiser campaign live till Oct 3rd! </span>
            <Link to="https://give.utexas.edu/national-medical-device-make-a-thon/?a=10643364" target="_blank" rel="noopener noreferrer">Donate Here!</Link>
            </div> */}

            <header>
                <span className="welcome">Join us March 6 - 8, 2026 for the 8th annual</span>
                <Header text=" " text2=" " tag="mdm" backgroundImage={HomeImage} />
                <div className="MDM">
                    <span>NATIONAL</span><br/><span>MEDICAL DEVICE</span><br/><span className="next-line">MAKE-A-THON</span>
                </div>
                {/* <CountdownTimer/> */}
                {/*<Map/>*/}
                <div className="hosts">
                    <span>Hosted by the University of Texas at Austin</span>
                </div>
            </header>

            <body>
            <hr/>
            <div className="about">
                <div className="about-general">
                    <h1> Overview </h1>
                    <p>
                        The Medical Device Make-A-Thon is a 48-hour competition where teams of students from diverse academic backgrounds
                        come together to conceptualize, design, and showcase a medical device solution to a real-world medical topic.
                        <br/><br/>
                        Participants will have the opportunity to showcase their creativity and
                        problem-solving skills while engaging in a fun, fast-paced environment.
                        <br/><br/>
                        Undergraduate students from all over the country are invited to participate
                        in this fun-filled weekend of networking and innovation!
                        <br/><br/>
                        All majors are welcome to compete!
                    </p>
                </div>
                <div className="about-this-year">
                    <h1>2026</h1>
                    <div className="partnership">
                        {/* <img src={require("../images/longhorn-logo.png")} alt={"UT Austin"} loading={"lazy"}/> */}
                    </div>
                    <h2 id="city-name">Austin, Texas</h2>
                    <h3>Friday, March 6 - Sunday, March 8</h3>
                    <br/><br/>
                    <div className="more-links">
                        <Link to="/info" className="information">More Information and FAQs</Link>
                        <Link to="https://www.instagram.com/nationalmdm2026/"
                              target="_blank"
                              rel="noopener noreferrer"
                              id="insta">
                            <img src={require("../images/instagram-small.png")} alt={"insta"} loading={"lazy"}/>
                        </Link>
                        <Link to="https://www.linkedin.com/company/national-medical-device-makeathon/"
                              target="_blank"
                              rel="noopener noreferrer"
                              id="linkedin">
                            <img src={require("../images/linkedin-logo-white.png")} alt={"insta"} loading={"lazy"}/>
                        </Link>
                        <Link to="/contact">
                            <img src={require("../images/mail.png")} alt={"mail"} loading={"lazy"}/>
                        </Link>
                    </div>

                    {/*<p>learn more button</p>*/}
                </div>
            </div>
            <hr/>

            <div className="more-info">
                <div className="info-box" id="workshop">
                    <h4>Workshop</h4>
                    <ul>
                        <li><span>Participate in SolidWorks, Fusion 360, and 3D Printing workshops to bring your designs to life</span></li>
                        <li><span>Receive mentorship from industry professionals to refine your design</span></li>
                        <li><span>Attend additional presentations designed to support your development</span></li>

                    </ul>
                </div>
                <div className="info-box">
                    <h4>Network</h4>
                    <ul>
                        <li><span>Engage with participants, industry professionals, and university faculty</span></li>
                        <li><span>Build connections with mentors and judges who are experts in their fields</span></li>
                        <li><span>Strengthen peer connections through collaboration and teamwork</span></li>
                    </ul>
                </div>
                <div className="info-box">
                    <h4>Compete</h4>
                    <ul>
                        <li><span>The top 12 teams will advance<br/>to the second round of judging</span></li>
                        <li><span>Showcase 3D-printed final prototypes to a panel of judges</span></li>
                        <li><span>Prize money will be awarded<br/>to the top 5 teams</span></li>
                        <li><span>1st-$800, 2nd-$600, 3rd-$400</span></li>
                    </ul>
                </div>
            </div>
            {/* <hr/> */}
            <div className="schools">
                {/*<h2> PARTICIPATING SCHOOLS </h2>*/}
                <h2>Participating Schools</h2>
                {/* <img src={require("../images/schools/University_of_Illinois_seal.png")} alt={"Illinois"} loading="lazy"/> */}
                <img src={require("../images/schools/University_of_Texas_Austin.png")} alt={"Austin"} loading="lazy"/>
                <img src={require("../images/schools/Texas_A&M_University_seal.png")} alt={"A&M"} loading="lazy"/>
                <img src={require("../images/schools/Duke_University_seal.png")} alt={"Duke"} loading="lazy"/>
                <img src={require("../images/schools/University_of_Iowa_seal.png")} alt={"Iowa"} loading="lazy"/>
                <img src={require("../images/schools/Wichita_State_University_seal.svg.png")} alt={"Wichita"} loading="lazy"/>
                <img src={require("../images/schools/University_of_Texas_at_San_Antonio_seal.svg.png")} alt={"UTSA"} loading="lazy"/>
                <img src={require("../images/schools/University_of_Texas_at_Arlington_seal.png")} alt={"UTSA"} loading="lazy"/>
                <img src={require("../images/schools/University_of Nebraska_seal.png")} alt={"Nebraska"} loading="lazy"/>
                <img src={require("../images/schools/University_of_Houston_seal.svg.png")} alt={"Houston"} loading="lazy"/>
                <img src={require("../images/schools/University_of_Missouri_seal.svg.png")} alt={"Missouri"} loading="lazy"/>
                {/* <img src={require("../images/schools/Southeast_Missouri_State_University_Seal.png")} alt={"SouthEast Missouri"} loading="lazy"/> */}
                <img className='imagetest' src={require("../images/schools/University_of_Oklahoma_seal.png")} alt={"Oklahoma"} loading="lazy"/>
                <img src={require("../images/schools/University_of_Central_Oklahoma.png")} alt={"Central Oklahoma"} loading="lazy"/>
                {/* <img src={require("../images/schools/University_of_Tulsa.png")} alt={"Tulsa"} loading="lazy"/> */}
                {/* <img src={require("../images/schools/Oral_Roberts_University.png")} alt={"ORU"} loading="lazy"/> */}
            </div>
            {/* <hr/> */}

            {/*<CountdownTimer />*/}

            <div className="testimonials">
                <h2>Testimonials</h2>
                <br/>
                <p>"I loved working with friends to solve a meaningful problem in a new and exciting way. Staying up for way too long and ping-ponging 
                    between 'it’s over' and 'we are so back'. The free food and awesome shirts were great too!"
                </p>
                <br/>
                <p>"My favorite part of the competition was the fast paced problem solving. Thinking of the different components to a design led to a
                    new type of innovation thought process that I would not have been exposed to at school."</p>
                <br/>
                <p>"My favorite part of the MDM experience was receiving first-hand feedback from real-world industry professionals.
                     I also loved having the opportunity to apply the foundational knowledge we’d been learning in lectures at Mizzou
                      to the medical device we designed and created."</p>
            </div>


            <div className="sponsor-page">
                {/*    ALL CURRENT SPONSORS    */}
                <div className="sponsors">
                    <h2> Sponsors </h2>
                    {/* 
                    <img src={"/sponsors/Society_of_Petroleum_Engineers_Logo.svg.png"}
                         alt={"Society of Petroleum Ingineers"} loading="lazy"/>
                    <img src={"/sponsors/Coca-Cola.png"} alt={"Coca-Cola"} loading="lazy"/>
                    <img src={"/sponsors/Medtronic.jpeg"} alt={"Medtronic"} loading="lazy"/>
                    <img src={"/sponsors/Immy.png"} alt={"Immy"} loading="lazy"/>
                    <img src={"/sponsors/red-bull.png"} alt={"Red Bull"} loading="lazy"/>
                    <img src={"/sponsors/OKBioStart.png"} alt={"OKBioStart"} loading="lazy"/> */}

                    <img src={"/sponsors/texas_am_engineering_medicine_logo.jpg"} alt={"Texas A&M"} loading="lazy"/>
                    {/* <img src={"/sponsors/BMES_Logo.webp"} alt={"BMES"} loading="lazy"/> */}
                    <img src={"/sponsors/SEC_logo.jpg"} alt={"SEC"} loading="lazy"/>
                    <img src={"/sponsors/Cockrell_CMYK_formal_BME-cropped.svg"} alt={"Cockrell School"} loading="lazy"/>
                    <img src={"/sponsors/BMES-UTaustin.png"} alt={"Cockrell School"} loading="lazy"/>
                    <img src={"/sponsors/sii_bruker_blifli_small_black.png"} alt={"Spectal Instruments Imaging"} loading="lazy"/>
                    <img src={"/sponsors/united_therapeutics.png"} alt={"United Therapeutics"} loading="lazy"/>
                    <img src={"/sponsors/Hi-Re-Logo.jpg"} alt={"Hi-Re"} loading="lazy"/>

                    {/* Use this as a place holder */}
                    {/*<img src={require("../images/logoplaceholder.png")} alt={"logo place holder"} id="placeholder"/>*/}

                </div>
            </div>

            <div className="partners-page">
                {/*    ALL CURRENT SPONSORS    */}
                <div className="partners">
                    <h2> Partners </h2>
                    <img src={"/sponsors/RGB_formal_Office_of_Innovation_and_Entrepreneurship.png"} alt={"RGB"} loading="lazy"/>
                    <img src={"/sponsors/ATI-logo.png"} alt={"ATI"} loading="lazy"/>

                    {/* Use this as a place holder */}
                    {/*<img src={require("../images/logoplaceholder.png")} alt={"logo place holder"} id="placeholder"/>*/}

                </div>
            </div>


{/* <!-- Winners Container --> */}
<div class="winners">
  <h2>Congratulations to the Winners!</h2>

  <div class="winners-container">

    {/* <!-- First Place --> */}
    <div class="winner-card">
      <h3>🥇 1st - MU Impact Black</h3>
      <p class="amount">$800 prize</p>
      <ul>
        <li>Andrew Brown — $160</li>
        <li>Emelia Hachenberger — $160</li>
        <li>Koen Straub — $160</li>
        <li>Riley Dycus — $160</li>
        <li>Delaney Rapp — $160</li>
      </ul>
    </div>

    {/* <!-- Second Place --> */}
    <div class="winner-card">
      <h3>🥈 2nd -  Simu-Life</h3>
      <p class="amount">$500 prize</p>
      <ul>
        <li>Seth Smith — $100</li>
        <li>Ethan Kua — $100</li>
        <li>Christina Tran — $100</li>
        <li>Ayla Bouzari — $100</li>
        <li>Robert Ozaeta — $100</li>
      </ul>
    </div>

    {/* <!-- Third Place --> */}
    <div class="winner-card">
      <h3>🥉 3rd - Team Gold</h3>
      <p class="amount">$200 prize</p>
      <ul>
        <li>Elizabeth Kilburg — $33.33</li>
        <li>Rebecca Flint — $33.33</li>
        <li>Maanit Sheth — $33.33</li>
        <li>Jack Petersen — $33.33</li>
        <li>Kristen Remley — $33.33</li>
        <li>Kate Pavletich — $33.33</li>
      </ul>
    </div>

  </div>

  <p class="note">
    * Award amounts are listed per individual recipient for tax reporting purposes.
  </p>
</div>



            {/* <div className="location-details">
                <h2> Event Map </h2>
                <img src={require("../images/eventMap.png")} alt={"Campus Temporary Map"} loading="lazy"/>
            </div> */}

            </body>
        </>
    );
};
export default Home;
